"use strict"; /// <reference lib="es2017" />

Object.defineProperty(exports, "__esModule", {
  value: true
});

var IncomingWebhook_1 = require("./IncomingWebhook");

exports.IncomingWebhook = IncomingWebhook_1.IncomingWebhook;

var errors_1 = require("./errors");

exports.ErrorCode = errors_1.ErrorCode;